import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'


const styles = {
  root: {
    margin: '50px auto',
    textAlign: 'center',
  },
}


const Loading = ({
  secondary, text, children, size,
  thickness, className, classes,
}) => (
  <div className={classNames(classes.root, className)}>
    <CircularProgress
      size={size}
      thickness={thickness}
      color={secondary ? 'secondary' : 'primary'}
    />

    {text && <Typography>{text}</Typography>}

    <div style={{ marginTop: children ? 10 : 0 }}>
      {children}
    </div>
  </div>
)


Loading.defaultProps = {
  size: 60,
  text: null,
  classes: {},
  children: [],
  thickness: 5,
  className: '',
  secondary: false,
}


Loading.propTypes = {
  text: PropTypes.string,
  size: PropTypes.number,
  children: PropTypes.node,
  secondary: PropTypes.bool,
  classes: PropTypes.object,
  thickness: PropTypes.number,
  className: PropTypes.string,
}


export default withStyles(styles)(Loading)
